exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment-actions__row{align-items:flex-start;display:flex;flex-direction:row;justify-content:space-between;position:relative;width:100%}.comment-actions__button{margin-right:20px}.comment-actions__faint{color:#959595}@media (prefers-color-scheme: dark){:root:not([data-theme=light]):not([data-theme=dark]) .comment-actions__faint{color:#fff}}:root[data-theme=dark] .comment-actions__faint{color:#fff}.comment-actions__moderator-tools{bottom:-35px;position:absolute;right:0;z-index:2}.comment-actions__last-button{margin-bottom:16px}\n", ""]);

// exports
exports.locals = {
	"comment-actions__row": "comment-actions__row",
	"comment-actions__button": "comment-actions__button",
	"comment-actions__faint": "comment-actions__faint",
	"comment-actions__moderator-tools": "comment-actions__moderator-tools",
	"comment-actions__last-button": "comment-actions__last-button"
};